function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { INTAKE_STATUS_DESCRIPTION, SOURCE_OF_DATE_LABEL } from "../../../constants/consts";
import { formatDate, monthDifference } from "../../../util/datetime";
export var isEslGapValid = function isEslGapValid(esl, application, option) {
  if (!application.program_esl) {
    return true;
  }
  var eslProgramMinLength = application.program_esl.min_length;
  if (!option) return true;

  // This is used to compare with the current selected option
  var comparedIntake = esl ? application.intake : application.intake_esl;
  if (!comparedIntake) return true;
  var diff = monthDifference(option, comparedIntake);
  return esl && diff <= (-eslProgramMinLength || 0) || !esl && diff >= (eslProgramMinLength || 0);
};

// Do not clear existing invalid intake in the dropdown.
export var optionsWithPrevInvalidIntake = function optionsWithPrevInvalidIntake(options, shouldExcludeInvalidOption, application, esl) {
  var selectedIntake = esl ? application.intake_esl : application.intake;
  var isIntakeValid = options.some(function (intake) {
    return selectedIntake === intake.value;
  });
  if (!isIntakeValid && !shouldExcludeInvalidOption) {
    var prevInvalidIntake = {
      label: formatDate(selectedIntake, 'YYYY - MMM.'),
      value: selectedIntake
    };

    /**
     * Adding the invalid intake to the end of the options is only for showing the
     * invalid intake value on an existing application which is not respecting the program esl min length.
     * If we are not showing the value, it might confuse users. And this does not affect new applications or
     * existing applications with valid intakes
     */
    return [].concat(_toConsumableArray(options), [prevInvalidIntake]);
  }
  return options;
};
export var getMinEslGapRespectedOptions = function getMinEslGapRespectedOptions(esl, application, options) {
  /**
   * Whenever ESL or Academic intake selection changes, the options for both dropdown
   * will be refreshed w.r.t its program's esl min length.
   */
  var selectedIntake = esl ? application.intake : application.intake_esl;
  var minEslGapRespectedOptions = !selectedIntake && options ||
  // If one of the two intake selections is null, ignore program esl min length.
  Array.isArray(options) && options.filter(
  // Filtering invalid intakes (i.e. Not respects program esl min length).
  function (option) {
    return isEslGapValid(esl, application, option.value);
  });
  return minEslGapRespectedOptions;
};
export function getIntakeStatusColor(status) {
  var statusMapping = {
    open: '#00ea86',
    open_conditionally: '#00ea86',
    will_open: '#36B37E',
    will_open_conditionally: '#36B37E',
    closed: '#FC8888',
    closed_conditionally: '#FC8888',
    likely_open: '#ffc179',
    waitlist: '#f29b3f'
  };
  return statusMapping[status];
}
export function generateIntakeTooltip(_ref) {
  var intakeSpecificStatus = _ref.intakeSpecificStatus,
    confirmedDeadline = _ref.confirmedDeadline,
    sourceDeadline = _ref.sourceDeadline,
    submissionDeadline = _ref.submissionDeadline;
  if (intakeSpecificStatus === 'waitlist') {
    var baseText = "The School has waitlisted this program intake but is still accepting applications.\n\nThere is no guarantee that the application will be processed but fees will still apply.";
    if (submissionDeadline && sourceDeadline && confirmedDeadline) {
      return "".concat(baseText, "\n\n").concat(INTAKE_STATUS_DESCRIPTION.submission_deadline).concat(submissionDeadline, " (Source: ").concat(SOURCE_OF_DATE_LABEL[sourceDeadline], " - Confirmation Date: ").concat(confirmedDeadline, ")");
    } else if (submissionDeadline && sourceDeadline) {
      return "".concat(baseText, "\n\n").concat(INTAKE_STATUS_DESCRIPTION.submission_deadline).concat(submissionDeadline, " (Source: ").concat(SOURCE_OF_DATE_LABEL[sourceDeadline], ")");
    } else if (submissionDeadline) {
      return "".concat(baseText, "\n\n").concat(INTAKE_STATUS_DESCRIPTION.submission_deadline).concat(submissionDeadline);
    }
    return baseText;
  }
  return INTAKE_STATUS_DESCRIPTION[intakeSpecificStatus];
}
export function getIntakeStatusText(status) {
  var labelMapping = {
    open: 'Open Now',
    open_conditionally: 'Open Now',
    will_open: 'Will Open',
    will_open_conditionally: 'Will Open',
    closed: 'Closed',
    closed_conditionally: 'Closed',
    likely_open: 'Likely Open',
    waitlist: 'Waitlist'
  };
  return labelMapping[status];
}